/**
 * Merge closed order-request pages into one list.
 *
 * History loads fulfilled and cancelled separately because the list API
 * accepts one status. Duplicate ids keep the later copy. Newest created_at
 * is first. A row with no parseable date stays after dated rows.
 *
 * @param {...Array<Object>} lists
 * @returns {Array<Object>}
 */
export function mergeOrderRequestHistoryLists(...lists) {
  const byId = new Map();
  lists.forEach(list => {
    (Array.isArray(list) ? list : []).forEach(row => {
      if (row == null || row.id == null) return;
      byId.set(row.id, row);
    });
  });

  return [...byId.values()].sort((a, b) => {
    const ta = Date.parse(a?.created_at);
    const tb = Date.parse(b?.created_at);
    const aTime = Number.isNaN(ta) ? null : ta;
    const bTime = Number.isNaN(tb) ? null : tb;
    if (aTime != null && bTime != null && aTime !== bTime) {
      return bTime - aTime;
    }
    if (aTime != null && bTime == null) return -1;
    if (aTime == null && bTime != null) return 1;
    return Number(b.id) - Number(a.id);
  });
}
